import React, { useState } from "react";
import { X, ChevronLeft, ChevronRight, Download, FileBadge } from "lucide-react";
import { atestImages } from "../catalog";

export default function AtestModal({ open, onClose }) {
  const [idx, setIdx] = useState(0);
  if (!open) return null;
  const next = () => setIdx((i) => (i + 1) % atestImages.length);
  const prev = () => setIdx((i) => (i - 1 + atestImages.length) % atestImages.length);
  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-3 md:p-8 bg-neutral-950/90 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-3xl max-w-4xl w-full max-h-[92vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 md:p-5 border-b border-neutral-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-neutral-950 flex items-center justify-center">
              <FileBadge className="w-5 h-5 text-amber-400" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-widest text-neutral-500">Zvanični dokument</div>
              <div className="font-display font-bold text-lg leading-tight">Atest / EU Izjava o sukladnosti</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <a
              href={atestImages[idx]}
              download
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-400 hover:bg-amber-300 text-neutral-950 text-sm font-semibold transition-colors"
            >
              <Download className="w-4 h-4" /> Preuzmi
            </a>
            <button
              onClick={onClose}
              className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-neutral-950 hover:text-white flex items-center justify-center transition-colors"
              aria-label="Zatvori"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="relative bg-neutral-100 flex-1 min-h-0 flex items-center justify-center">
          <img
            src={atestImages[idx]}
            alt={`Atest ${idx + 1}`}
            className="max-w-full max-h-[70vh] object-contain"
          />
          <button
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow hover:bg-amber-400 text-neutral-950 flex items-center justify-center transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow hover:bg-amber-400 text-neutral-950 flex items-center justify-center transition-colors"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
        <div className="p-3 border-t border-neutral-200 flex items-center justify-center gap-2">
          {atestImages.map((im, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`w-14 h-14 rounded-lg overflow-hidden border-2 ${
                i === idx ? "border-amber-400" : "border-neutral-200"
              }`}
            >
              <img src={im} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
          <a
            href={atestImages[idx]}
            download
            className="sm:hidden inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-400 hover:bg-amber-300 text-neutral-950 text-sm font-semibold transition-colors"
          >
            <Download className="w-4 h-4" /> Preuzmi
          </a>
        </div>
      </div>
    </div>
  );
}
